module.exports = __webpack_public_path__ + "static/media/croft.166ec176.png";